export default "__VITE_ASSET__CQa6d9Uy__"